// 用户详情
export default {
    heard_title: "User Details",
    heard_btn: "Return",
    // userInfo
    recharge_btn: "Recharge",
    tl_nickName: "nickname",
    tl_age: "Age",
    tl_gender: "Gender",
    tl_address: "City",
    tl_level: "Level",
    tl_experience: "Experience",
    tl_createTime: "Registration time",
    tl_activityTime: "Last login time",
    tl_channel: "Channel",
    tl_storeName: "Store",
    tp_store: "Please select",
    // statistic表格
    t_title_statistics: "Statistics",
    tl_balance: "Account Balance",
    tl_rechargeAmout: "Total recharge amount",
    tl_rechargeQuantity: "Number of recharges",
    tl_consumeQuantity: "Consume Count",
    tl_orderQuantity: "Order Quantity",
    tl_frequency: "Visit Days",
    tl_gameQuantity: "Number of Games",
    tl_refundOrderQuantity: "Refund Record",
    tl_evaluateQuantity: "Evaluate",
    tl_couponQuantity: "Coupon",
    tl_inviteQuantity: "Invite Friend",
    // tab1
    tab_label_game: "Competition record",
    tab_tl_frequency: "Visit",
    tab_tl_sequence: "How many times to participate",
    tab_tl_syncDate: "Date",
    tab_tl_syncTime: "Time",
    tab_tl_scheduleCode: "Schedule",
    tab_tl_scheduleTitle: "Project",
    tab_tl_bestTime: "Best Score",
    tab_tl_ranking: "Ranking",
    tab_tl_originalExperience: "Experience",
    tab_btn_viewReport: "View Grades",
    // tab2
    tab_label_recharge: "Recharge Record",
    tab_tl_rank: "Rank",
    tab_tl_payTime: "Time",
    tab_tl_amount: "Amount",
    tab_tl_balance: "Balance",
    // tab3
    tab_label_order: "Order Record",
    tab_tl_no: "Order number",
    tab_tl_createTime: "Create Time",
    tab_tl_acount: "User Account",
    tab_tl_totalAmount: "Order Amount",
    tab_tl_status: "Order Status",
    tab_tl_payWay: "Payment Method",
    tab_tl_regChannel: "Channel",
    // 成绩表
    dt_reportTable: "Grade List",
    dl_number: "Number of laps",
    dl_report: "Grade",
    dl_experience: "Experience",
    // 支付提示
    dl_payAmount: "Payment Amount:",
    dl_payUnit: "yuan",
    dl_payWay: "Payment method",
    // 充值表单
    dt_recharge: "Recharge",
    dl_rechargeAmount: "Recharge Amount",
    dp_rechargeAmount: "recharge amount",
    dl_payModel: "Payment method",
    dp_payModel: "payment method",
    ol_wechatpay: "Wechat Pay",
    ol_cash: "Cash",
    ol_pos: "swipe card",
    ol_other: "Other",
    ol_alipay: "Alipay",
    dl_authCode: "Payment code:",
    dp_authCode: "scan the payment code",
    dl_rewardAmount: "Recharge activity:",
    dp_rewardAmount: "Please select",
    dl_dicount: "Membership card recharge:",
    dp_dicount: "Please select",
    pay_tip1: "Successful payment",
    pay_tip2: "Payment failed",
    pay_tip3: "Payment result unknown",
    pay_step1: "OK",
    pay_step2: "Repay",
    em_authCode: "The payment code cannot be empty",
    ft_channel_mini: "WeChat Mini Program",
    ft_channel_web: "computer web page",
    ft_payWay_wechartpay: "WeChat Pay",
    ft_payWay_alipay: "Alipay",
    ft_payWay_wallet: "Membership Card",
    ft_payWay_card: "MemberCard",
    ft_payWay_cash: "Cash",
    ft_payWay_pos: "Swipe card",
    ft_payWay_other: "Other",
    ft_status_notConfirmed: "Pending Payment",
    ft_status_confirmed: "To be used",
    ft_status_close: "Close",
    ft_status_completed: "Completed",
    ft_status_canceled: "Canceled"
};
